import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { EditorialArticleShell, useEditorialNav } from './EditorialArticleShell';
import { getExamContent, getExamKeyFromHost, getExamSiteOrigin } from './examContext';
import { ExternalRedirect, pathbuddyInsightTarget } from './pathbuddyInsightRedirects';

export default function ExamInsightsArticlePage() {
  const { slug } = useParams();
  const examKey = getExamKeyFromHost();
  const { navigate } = useEditorialNav(examKey);
  const content = getExamContent(examKey);
  const article = content.articles?.[slug];

  if (examKey === 'pathbuddy') {
    return <ExternalRedirect href={pathbuddyInsightTarget(slug)} />;
  }
  if (!article) {
    return <Navigate to="/insights" replace />;
  }

  const label = content.insights_label || `${content.exam} Insights`;
  const origin = getExamSiteOrigin(examKey);
  const pageUrl = `${origin}/insights/${slug}`;
  const publisherName = examKey === 'pathbuddy' ? 'Pathbuddy' : 'ivori';
  const publisherUrl = examKey === 'pathbuddy' ? 'https://pathbuddy.com' : 'https://ivoriai.com/';
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Article",
        "headline": article.title,
        "description": article.meta,
        "url": pageUrl,
        "publisher": { "@type": "Organization", "name": publisherName, "url": publisherUrl }
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Home", "item": origin },
          { "@type": "ListItem", "position": 2, "name": label, "item": `${origin}/insights` },
          { "@type": "ListItem", "position": 3, "name": article.title, "item": pageUrl }
        ]
      }
    ]
  };

  return (
    <EditorialArticleShell
      examKey={examKey}
      title={`${article.title} | ${label}`}
      description={article.meta}
      url={pageUrl}
      schema={schema}
      keywords={
        examKey === 'pathbuddy'
          ? `${article.title}, reasoning education, critical thinking, problem solving, grammar school, private school, Pathbuddy`
          : undefined
      }
      backLabel="← Back to Insights"
      onBack={() => navigate('/insights')}
      eyebrow={article.eyebrow}
      heading={article.title}
      meta={article.meta}
      bodyHtml={article.body_html}
    />
  );
}
